import { useEffect, useState } from "react";
import { useBusiness } from "../../contexts/BusinessContext";
import { useNavigate } from "react-router-dom";
import { apiUrls } from "../../config/apiUrls.const";
import { Button, Spinner } from "react-bootstrap";
import { _post } from "../../services/apiClient";
import React from "react";
import ItemCard from "../Service/ItemCard";
import { logout } from "../../services/authService";

export default function Categorization() {
  const { business } = useBusiness();
  const [spaData, setSpaData] = useState<any[] | null>(null);
  const [parlorData, setParlorData] = useState<any[] | null>(null);
  const [salonData, setSalonData] = useState<any[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<string>("nodata");
  const navigate = useNavigate();

  useEffect(() => {
    fetchServices();
  }, [business]);

  const fetchServices = async () => {
    if (!business?.biz_code) return;

    setLoading(true);
    try {
      const res: any = await _post(apiUrls.getBusinessCategorization,
        {biz_code: business.biz_code},
        // {skipGlobalSuccess: true}
      );

      if (res.data?.success && res.data?.data) {
        const data = res.data.data;
        setError(null);
        setSpaData(data?.spa || null);
        setParlorData(data?.parlor || null);
        setSalonData(data?.salon || null);
        // Update context services if business exists (avoid calling non-existent setter)
        if (business) {
          business.services = data;
          if (business?.services) {
            const { spa, parlor, salon } = business.services;
            if (spa) setActiveTab("spa");
            else if (parlor) setActiveTab("parlor");
            else if (salon) setActiveTab("salon");
            else setActiveTab("nodata");
          }
        }
      } else {
        setError(res.message || "Failed to load data.");
      }
    } catch (err:any) {
      if(err?.response?.status == 401){
        logout();
        return;
      }
      console.error(err);
      setError("Error fetching categorization data.");
    } finally {
      setLoading(false);
    }
  };

  

  if (loading)
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p>Loading Categorization...</p>
      </div>
    );

  if (error)
    return (
      <div className="alert alert-danger text-center">
        {error}
        <br />
        <Button onClick={fetchServices} size="sm">
          Retry
        </Button>
      </div>
    );

  // Prepare the tab data dynamically
  const tabs = [
    { key: "spa", label: "Spa Services", data: spaData },
    { key: "parlor", label: "Parlor Services", data: parlorData },
    { key: "salon", label: "Salon Services", data: salonData },
    { key: "nodata", label: "No Data Available", data: [] },
  ].filter((tab) => tab.data && tab.data.length > 0);

  if (tabs.length === 0)
    return (
      <div className="container-fluid p-0">
        <h1 className="h3 mb-3">
          Categorization
        </h1>
        <div className="row">
          <div className="container text-center bg-white p-5">
            <h2 className="text-center mb-4">
              <div className="text-danger">No Data Found</div>
            </h2>
            <Button variant="primary" onClick={() => navigate("/edit-categorization")}>
              Set Categorization
            </Button>
          </div>
        </div>
      </div>);

  return (
    <div className="container-fluid p-0">
      <h1 className="h3 mb-3">
        Categorization
        <Button className="float-end" variant="primary" size="sm" onClick={() =>
            navigate("/edit-categorization", {
              state: {
                spaData,
                parlorData,
                salonData,
              },
            })
          }>
          Edit
        </Button>
      </h1>

      {/* Dynamic Tabs */}
      <div className="row">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-body p-0 border-0">
              <ul className="nav nav-tabs">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.key}>
                    <button
                      className={`nav-link ${
                        activeTab === tab.key ? "active" : ""
                      }`}
                      onClick={() => setActiveTab(tab.key)}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>

              <div className="tab-content border p-3">
                {tabs.map((tab) => (
                  <div
                    key={tab.key}
                    className={`tab-pane fade ${
                      activeTab === tab.key ? "show active" : ""
                    }`}
                  >
                    <div className="row mb-2">
                    {tab.data && tab.data.length > 0 ? (
                      tab.data.map((bizCategory: any) => (
                        
                          <React.Fragment key={bizCategory.category.id}>
                              <div className="col-md-3 col-sm-4 col-12">
                                <div className="mb-2"><b>{bizCategory.category?.name_en}</b></div>
                                  <ul className="list-group bg-white mb-3">
                                    {bizCategory.subcategories && bizCategory.subcategories.length > 0 ? (
                                      bizCategory.subcategories.map((getSubcategory: any) => (
                                        <li
                                          className="list-group-item bg-white"
                                          key={getSubcategory.id}
                                        >
                                          {getSubcategory?.subcategory?.name_en}

                                          {/* <ItemCard
                                            item={{
                                              id: getItem.id,
                                              name_en: getItem.item.name_en,
                                              duration: getItem.duration,
                                              price: getItem.price,
                                              defaultImage: getItem?.default_image?.image_url || ''
                                            }}
                                            onUpdate={(updatedItem) => {
                                              console.log("Updated:", updatedItem);
                                              // You can trigger your API update call here
                                            }}
                                          /> */}
                                        </li>
                                      ))
                                    ) : (
                                      <div className="text-center text-danger">No Data Found</div>
                                    )}
                                  </ul>
                              </div>
                          </React.Fragment>
                      ))
                    ) : (
                      <div className="text-center text-danger">No Data Found</div>
                    )}
                  </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}